import { faker } from '@faker-js/faker';
import React, { useState } from 'react'
import { Card, Button, Avatar, Drawer, Space, message } from 'antd'
import { DeleteOutlined, UserOutlined } from '@ant-design/icons';
import { Container } from 'react-bootstrap';
import { deleteDocumentByName } from '../../firebase';


const { Meta } = Card;

export default function CarCard(props) {
  const[deleteLoading, setDeleteLoading] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const[deleted, setDeleted] = useState(false)

  const success = () => {
    messageApi.open({
      type: 'success',
      content: 'The post was successfully deleted.',
    });
  };

  if(deleted){
    return null;
  }

  return (
    <Card title={props.item.catType} style={{width: '100%', justifyContent: 'center'}}
    cover={
      <img
      alt="Car Picture"
      src={props.item.catImage}
      />
    }
    
    // actions={[
    //     <DeleteOutlined onClick={() => { }} />
    //   ]}  
    >
      {contextHolder}

    <Meta
      avatar={<Avatar src={props.item.profileImage}/>}
      title={props.item.name}
      description={props.item.month + " "+  props.item.year}
      style={{marginBottom: '20px'}}
      />
  <Space direction='horizontal'>
  </Space>
  {props.admin ?   <Container className="d-flex align-items-center justify-content-center">
        <Button type='primary' className='align-items-center justify-content-center' loading={deleteLoading} danger onClick={() => { 
            setDeleteLoading(true)
            deleteDocumentByName(props.item.name)
            setTimeout(() => {
              setDeleteLoading(false)
              success()
            }, 2000)

         }}>
            Delete Post
        </Button>
  </Container> : null}
    </Card>

    
  )
}
